/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
};

/** Autogenerated input type of AccountSettingsUpdate */
export type AccountSettingsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  digestPreference?: InputMaybe<DigestPreference>;
  locations?: InputMaybe<Array<UserLocationInput>>;
};

/** Autogenerated return type of AccountSettingsUpdate. */
export type AccountSettingsUpdatePayload = {
  __typename?: 'AccountSettingsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Auth type */
export type AuthType =
  | 'SESSION'
  | 'TOKEN';

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  /** Human-readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  reasons?: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  value: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CredentialsUserAuth */
export type CredentialsUserAuthInput = {
  authType?: InputMaybe<AuthType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
};

/** Autogenerated return type of CredentialsUserAuth. */
export type CredentialsUserAuthPayload = {
  __typename?: 'CredentialsUserAuthPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csrfToken: Scalars['String']['output'];
  user?: Maybe<User>;
};

/** Email digest frequency preference */
export type DigestPreference =
  | 'DAILY'
  | 'OFF'
  | 'WEEKLY';

/** Autogenerated input type of EmailTokenUserAuth */
export type EmailTokenUserAuthInput = {
  authType?: InputMaybe<AuthType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated return type of EmailTokenUserAuth. */
export type EmailTokenUserAuthPayload = {
  __typename?: 'EmailTokenUserAuthPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csrfToken: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EmailUserAuthChallenge */
export type EmailUserAuthChallengeInput = {
  clientAuthCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of EmailUserAuthChallenge. */
export type EmailUserAuthChallengePayload = {
  __typename?: 'EmailUserAuthChallengePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FailureReasons = {
  __typename?: 'FailureReasons';
  /** JSON-encoded map of reasons */
  details: Scalars['String']['output'];
  /** Human-readable errors */
  fullMessages: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of InternalAdminAddKeyword */
export type InternalAdminAddKeywordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  keyword: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminAddKeyword. */
export type InternalAdminAddKeywordPayload = {
  __typename?: 'InternalAdminAddKeywordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of InternalAdminDeleteKeyword */
export type InternalAdminDeleteKeywordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  keywordId: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminDeleteKeyword. */
export type InternalAdminDeleteKeywordPayload = {
  __typename?: 'InternalAdminDeleteKeywordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of InternalAdminImportWaitlistKeywords */
export type InternalAdminImportWaitlistKeywordsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  waitlistEntryId: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminImportWaitlistKeywords. */
export type InternalAdminImportWaitlistKeywordsPayload = {
  __typename?: 'InternalAdminImportWaitlistKeywordsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type InternalAdminKeywordInput = {
  active: Scalars['Boolean']['input'];
  keyword: Scalars['String']['input'];
};

/** Autogenerated input type of InternalAdminUpdateKeyword */
export type InternalAdminUpdateKeywordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  keyword: Scalars['String']['input'];
  keywordId: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminUpdateKeyword. */
export type InternalAdminUpdateKeywordPayload = {
  __typename?: 'InternalAdminUpdateKeywordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  searchKeyword: SearchKeyword;
};

/** Autogenerated input type of InternalAdminUpdateWaitlistExpandedKeywords */
export type InternalAdminUpdateWaitlistExpandedKeywordsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expandedKeywords: Array<Scalars['String']['input']>;
  waitlistEntryId: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminUpdateWaitlistExpandedKeywords. */
export type InternalAdminUpdateWaitlistExpandedKeywordsPayload = {
  __typename?: 'InternalAdminUpdateWaitlistExpandedKeywordsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  waitlistEntry: WaitlistEntry;
};

export type InternalAdminUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userRole?: InputMaybe<UserRole>;
  userStatus?: InputMaybe<UserStatus>;
};

/** Autogenerated input type of InternalAdminUserSearchSettingsUpdate */
export type InternalAdminUserSearchSettingsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  keywords: Array<InternalAdminKeywordInput>;
  locations: Array<UserLocationInput>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminUserSearchSettingsUpdate. */
export type InternalAdminUserSearchSettingsUpdatePayload = {
  __typename?: 'InternalAdminUserSearchSettingsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of InternalAdminUserUpdate */
export type InternalAdminUserUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  userInput: InternalAdminUserInput;
};

/** Autogenerated return type of InternalAdminUserUpdate. */
export type InternalAdminUserUpdatePayload = {
  __typename?: 'InternalAdminUserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type Listing = Node & {
  __typename?: 'Listing';
  createdAt: Scalars['ISO8601DateTime']['output'];
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  keyword: Scalars['String']['output'];
  listingUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Listing. */
export type ListingConnection = {
  __typename?: 'ListingConnection';
  /** A list of edges. */
  edges: Array<ListingEdge>;
  /** A list of nodes. */
  nodes: Array<Listing>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ListingEdge = {
  __typename?: 'ListingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Listing>;
};

/** Autogenerated input type of Logout */
export type LogoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Logout. */
export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accountSettingsUpdate: AccountSettingsUpdatePayload;
  credentialsUserAuth: CredentialsUserAuthPayload;
  /** Authenticate a user with an email token */
  emailTokenUserAuth: EmailTokenUserAuthPayload;
  /** Send an email to the user with a challenge code */
  emailUserAuthChallenge: EmailUserAuthChallengePayload;
  internalAdminAddKeyword: InternalAdminAddKeywordPayload;
  internalAdminDeleteKeyword: InternalAdminDeleteKeywordPayload;
  /** Import waitlist keywords into a matched user account */
  internalAdminImportWaitlistKeywords: InternalAdminImportWaitlistKeywordsPayload;
  internalAdminUpdateKeyword: InternalAdminUpdateKeywordPayload;
  internalAdminUpdateWaitlistExpandedKeywords: InternalAdminUpdateWaitlistExpandedKeywordsPayload;
  internalAdminUserSearchSettingsUpdate: InternalAdminUserSearchSettingsUpdatePayload;
  /** Updates a user by id */
  internalAdminUserUpdate: InternalAdminUserUpdatePayload;
  logout: LogoutPayload;
  searchKeywordCreate: SearchKeywordCreatePayload;
  searchKeywordDelete: SearchKeywordDeletePayload;
  searchKeywordReorder: SearchKeywordReorderPayload;
  searchKeywordToggle: SearchKeywordTogglePayload;
  searchKeywordUpdate: SearchKeywordUpdatePayload;
  /** Create an account and send a magic link, or resend to an existing account */
  userSignup: UserSignupPayload;
  /** Updates the current viewer */
  viewerUpdate: ViewerUpdatePayload;
  watchedListingCreate: WatchedListingCreatePayload;
  watchedListingDelete: WatchedListingDeletePayload;
};


export type MutationAccountSettingsUpdateArgs = {
  input: AccountSettingsUpdateInput;
};


export type MutationCredentialsUserAuthArgs = {
  input: CredentialsUserAuthInput;
};


export type MutationEmailTokenUserAuthArgs = {
  input: EmailTokenUserAuthInput;
};


export type MutationEmailUserAuthChallengeArgs = {
  input: EmailUserAuthChallengeInput;
};


export type MutationInternalAdminAddKeywordArgs = {
  input: InternalAdminAddKeywordInput;
};


export type MutationInternalAdminDeleteKeywordArgs = {
  input: InternalAdminDeleteKeywordInput;
};


export type MutationInternalAdminImportWaitlistKeywordsArgs = {
  input: InternalAdminImportWaitlistKeywordsInput;
};


export type MutationInternalAdminUpdateKeywordArgs = {
  input: InternalAdminUpdateKeywordInput;
};


export type MutationInternalAdminUpdateWaitlistExpandedKeywordsArgs = {
  input: InternalAdminUpdateWaitlistExpandedKeywordsInput;
};


export type MutationInternalAdminUserSearchSettingsUpdateArgs = {
  input: InternalAdminUserSearchSettingsUpdateInput;
};


export type MutationInternalAdminUserUpdateArgs = {
  input: InternalAdminUserUpdateInput;
};


export type MutationLogoutArgs = {
  input: LogoutInput;
};


export type MutationSearchKeywordCreateArgs = {
  input: SearchKeywordCreateInput;
};


export type MutationSearchKeywordDeleteArgs = {
  input: SearchKeywordDeleteInput;
};


export type MutationSearchKeywordReorderArgs = {
  input: SearchKeywordReorderInput;
};


export type MutationSearchKeywordToggleArgs = {
  input: SearchKeywordToggleInput;
};


export type MutationSearchKeywordUpdateArgs = {
  input: SearchKeywordUpdateInput;
};


export type MutationUserSignupArgs = {
  input: UserSignupInput;
};


export type MutationViewerUpdateArgs = {
  input: ViewerUpdateInput;
};


export type MutationWatchedListingCreateArgs = {
  input: WatchedListingCreateInput;
};


export type MutationWatchedListingDeleteArgs = {
  input: WatchedListingDeleteInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  internalAdminUsers: UserConnection;
  internalAdminWaitlistEntries: WaitlistEntryConnection;
  listings: ListingConnection;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  searchKeywords: Array<SearchKeyword>;
  uiAccess: UiAccess;
  viewer?: Maybe<User>;
  watchedListings: Array<WatchedListing>;
};


export type QueryInternalAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInternalAdminWaitlistEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endingToday?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keywords: Array<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNodesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SearchKeyword = Node & {
  __typename?: 'SearchKeyword';
  active: Scalars['Boolean']['output'];
  activeListingCount: Scalars['Int']['output'];
  auctionNinjaCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  ctbidsCount: Scalars['Int']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  keyword: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  recentListings: Array<Listing>;
};

/** Autogenerated input type of SearchKeywordCreate */
export type SearchKeywordCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  keyword: Scalars['String']['input'];
};

/** Autogenerated return type of SearchKeywordCreate. */
export type SearchKeywordCreatePayload = {
  __typename?: 'SearchKeywordCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  searchKeyword?: Maybe<SearchKeyword>;
};

/** Autogenerated input type of SearchKeywordDelete */
export type SearchKeywordDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SearchKeywordDelete. */
export type SearchKeywordDeletePayload = {
  __typename?: 'SearchKeywordDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SearchKeywordReorder */
export type SearchKeywordReorderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of SearchKeywordReorder. */
export type SearchKeywordReorderPayload = {
  __typename?: 'SearchKeywordReorderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SearchKeywordToggle */
export type SearchKeywordToggleInput = {
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SearchKeywordToggle. */
export type SearchKeywordTogglePayload = {
  __typename?: 'SearchKeywordTogglePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  searchKeyword?: Maybe<SearchKeyword>;
};

/** Autogenerated input type of SearchKeywordUpdate */
export type SearchKeywordUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  keyword: Scalars['String']['input'];
};

/** Autogenerated return type of SearchKeywordUpdate. */
export type SearchKeywordUpdatePayload = {
  __typename?: 'SearchKeywordUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  searchKeyword?: Maybe<SearchKeyword>;
};

/** UI access permissions for the current user */
export type UiAccess = {
  __typename?: 'UiAccess';
  canInternalAdmin: AuthorizationResult;
};

export type User = Node & {
  __typename?: 'User';
  avatarThumbUrl?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  digestPreference: DigestPreference;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  searchKeywords: Array<SearchKeyword>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userLocations: Array<UserLocation>;
  userRole: UserRole;
  userStatus: UserStatus;
  waitlistEntry?: Maybe<WaitlistEntry>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserLocation = Node & {
  __typename?: 'UserLocation';
  cityZip: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  radius: Scalars['String']['output'];
};

export type UserLocationInput = {
  cityZip: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  radius: Scalars['String']['input'];
};

/** User role enum */
export type UserRole =
  | 'DEFAULT'
  | 'SYSTEM_ADMIN';

/** Autogenerated input type of UserSignup */
export type UserSignupInput = {
  clientAuthCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
};

/** Autogenerated return type of UserSignup. */
export type UserSignupPayload = {
  __typename?: 'UserSignupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** User status enum */
export type UserStatus =
  | 'ACTIVE'
  | 'BLOCKED'
  | 'INVITED';

export type ViewerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ViewerUpdate */
export type ViewerUpdateInput = {
  avatarSignedId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  removeAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  viewerInput: ViewerInput;
};

/** Autogenerated return type of ViewerUpdate. */
export type ViewerUpdatePayload = {
  __typename?: 'ViewerUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type WaitlistEntry = Node & {
  __typename?: 'WaitlistEntry';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  expandedKeywords?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  matchedUser?: Maybe<User>;
};

/** The connection type for WaitlistEntry. */
export type WaitlistEntryConnection = {
  __typename?: 'WaitlistEntryConnection';
  /** A list of edges. */
  edges: Array<WaitlistEntryEdge>;
  /** A list of nodes. */
  nodes: Array<WaitlistEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type WaitlistEntryEdge = {
  __typename?: 'WaitlistEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WaitlistEntry>;
};

export type WatchedListing = Node & {
  __typename?: 'WatchedListing';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  listing: Listing;
};

/** Autogenerated input type of WatchedListingCreate */
export type WatchedListingCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  listingId: Scalars['ID']['input'];
};

/** Autogenerated return type of WatchedListingCreate. */
export type WatchedListingCreatePayload = {
  __typename?: 'WatchedListingCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  watchedListing?: Maybe<WatchedListing>;
};

/** Autogenerated input type of WatchedListingDelete */
export type WatchedListingDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of WatchedListingDelete. */
export type WatchedListingDeletePayload = {
  __typename?: 'WatchedListingDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersQuery = { __typename?: 'Query', internalAdminUsers: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, fullName: string, email?: string | null, createdAt?: string | null, searchKeywords: Array<{ __typename?: 'SearchKeyword', id: string, keyword: string }>, waitlistEntry?: { __typename?: 'WaitlistEntry', keywords?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type UserSearchSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserSearchSettingsQuery = { __typename?: 'Query', node?:
    | { __typename?: 'Listing' }
    | { __typename?: 'SearchKeyword' }
    | { __typename?: 'User', id: string, fullName: string, email?: string | null, searchKeywords: Array<{ __typename?: 'SearchKeyword', id: string, keyword: string, active: boolean, position?: number | null }>, userLocations: Array<{ __typename?: 'UserLocation', id: string, position: number, cityZip: string, radius: string }> }
    | { __typename?: 'UserLocation' }
    | { __typename?: 'WaitlistEntry' }
    | { __typename?: 'WatchedListing' }
   | null };

export type AdminUserSearchSettingsUpdateMutationVariables = Exact<{
  input: InternalAdminUserSearchSettingsUpdateInput;
}>;


export type AdminUserSearchSettingsUpdateMutation = { __typename?: 'Mutation', internalAdminUserSearchSettingsUpdate: { __typename?: 'InternalAdminUserSearchSettingsUpdatePayload', user: { __typename?: 'User', id: string, searchKeywords: Array<{ __typename?: 'SearchKeyword', id: string, keyword: string, active: boolean, position?: number | null }>, userLocations: Array<{ __typename?: 'UserLocation', id: string, position: number, cityZip: string, radius: string }> } } };

export type InternalAdminAddKeywordMutationVariables = Exact<{
  input: InternalAdminAddKeywordInput;
}>;


export type InternalAdminAddKeywordMutation = { __typename?: 'Mutation', internalAdminAddKeyword: { __typename?: 'InternalAdminAddKeywordPayload', user: { __typename?: 'User', id: string, searchKeywords: Array<{ __typename?: 'SearchKeyword', id: string, keyword: string }>, waitlistEntry?: { __typename?: 'WaitlistEntry', keywords?: string | null } | null } } };

export type InternalAdminDeleteKeywordMutationVariables = Exact<{
  input: InternalAdminDeleteKeywordInput;
}>;


export type InternalAdminDeleteKeywordMutation = { __typename?: 'Mutation', internalAdminDeleteKeyword: { __typename?: 'InternalAdminDeleteKeywordPayload', success: boolean } };

export type AdminWaitlistQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminWaitlistQuery = { __typename?: 'Query', internalAdminWaitlistEntries: { __typename?: 'WaitlistEntryConnection', edges: Array<{ __typename?: 'WaitlistEntryEdge', node?: { __typename?: 'WaitlistEntry', id: string, email: string, keywords?: string | null, expandedKeywords?: string | null, createdAt: string, matchedUser?: { __typename?: 'User', id: string, fullName: string } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type ImportWaitlistKeywordsMutationVariables = Exact<{
  input: InternalAdminImportWaitlistKeywordsInput;
}>;


export type ImportWaitlistKeywordsMutation = { __typename?: 'Mutation', internalAdminImportWaitlistKeywords: { __typename?: 'InternalAdminImportWaitlistKeywordsPayload', user: { __typename?: 'User', id: string, fullName: string } } };

export type UpdateWaitlistExpandedKeywordsMutationVariables = Exact<{
  input: InternalAdminUpdateWaitlistExpandedKeywordsInput;
}>;


export type UpdateWaitlistExpandedKeywordsMutation = { __typename?: 'Mutation', internalAdminUpdateWaitlistExpandedKeywords: { __typename?: 'InternalAdminUpdateWaitlistExpandedKeywordsPayload', waitlistEntry: { __typename?: 'WaitlistEntry', id: string, expandedKeywords?: string | null } } };

export type CachedUiAccessContextFragment = { __typename?: 'UiAccess', canInternalAdmin: { __typename?: 'AuthorizationResult', value: boolean } };

export type CachedViewerContextFragment = { __typename?: 'User', id: string, fullName: string, firstName: string, lastName: string, email?: string | null, createdAt?: string | null, avatarThumbUrl?: string | null };

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutPayload', success: boolean } };

export type UiAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type UiAccessQuery = { __typename?: 'Query', uiAccess: { __typename?: 'UiAccess', canInternalAdmin: { __typename?: 'AuthorizationResult', value: boolean } } };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, fullName: string, firstName: string, lastName: string, email?: string | null, createdAt?: string | null, avatarThumbUrl?: string | null } | null };

export type SearchKeywordsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchKeywordsQuery = { __typename?: 'Query', searchKeywords: Array<{ __typename?: 'SearchKeyword', id: string, keyword: string, active: boolean, position?: number | null, createdAt: string, activeListingCount: number, auctionNinjaCount: number, ctbidsCount: number }> };

export type ListingsQueryVariables = Exact<{
  keywords: Array<Scalars['String']['input']> | Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  endingToday?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListingsQuery = { __typename?: 'Query', listings: { __typename?: 'ListingConnection', edges: Array<{ __typename?: 'ListingEdge', node?: { __typename?: 'Listing', id: string, title?: string | null, price?: string | null, photoUrl?: string | null, listingUrl?: string | null, endsAt?: string | null, location?: string | null, source: string } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type SearchKeywordCreateMutationVariables = Exact<{
  input: SearchKeywordCreateInput;
}>;


export type SearchKeywordCreateMutation = { __typename?: 'Mutation', searchKeywordCreate: { __typename?: 'SearchKeywordCreatePayload', searchKeyword?: { __typename?: 'SearchKeyword', id: string, keyword: string, active: boolean, position?: number | null, createdAt: string, activeListingCount: number, auctionNinjaCount: number, ctbidsCount: number } | null } };

export type SearchKeywordDeleteMutationVariables = Exact<{
  input: SearchKeywordDeleteInput;
}>;


export type SearchKeywordDeleteMutation = { __typename?: 'Mutation', searchKeywordDelete: { __typename?: 'SearchKeywordDeletePayload', success: boolean } };

export type SearchKeywordReorderMutationVariables = Exact<{
  input: SearchKeywordReorderInput;
}>;


export type SearchKeywordReorderMutation = { __typename?: 'Mutation', searchKeywordReorder: { __typename?: 'SearchKeywordReorderPayload', success: boolean } };

export type SearchKeywordUpdateMutationVariables = Exact<{
  input: SearchKeywordUpdateInput;
}>;


export type SearchKeywordUpdateMutation = { __typename?: 'Mutation', searchKeywordUpdate: { __typename?: 'SearchKeywordUpdatePayload', searchKeyword?: { __typename?: 'SearchKeyword', id: string, keyword: string } | null } };

export type WatchedListingsQueryVariables = Exact<{ [key: string]: never; }>;


export type WatchedListingsQuery = { __typename?: 'Query', watchedListings: Array<{ __typename?: 'WatchedListing', id: string, listing: { __typename?: 'Listing', id: string } }> };

export type WatchedListingCreateMutationVariables = Exact<{
  input: WatchedListingCreateInput;
}>;


export type WatchedListingCreateMutation = { __typename?: 'Mutation', watchedListingCreate: { __typename?: 'WatchedListingCreatePayload', watchedListing?: { __typename?: 'WatchedListing', id: string, listing: { __typename?: 'Listing', id: string } } | null } };

export type WatchedListingDeleteMutationVariables = Exact<{
  input: WatchedListingDeleteInput;
}>;


export type WatchedListingDeleteMutation = { __typename?: 'Mutation', watchedListingDelete: { __typename?: 'WatchedListingDeletePayload', success: boolean } };

export type NavUserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type NavUserSettingsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, digestPreference: DigestPreference, userLocations: Array<{ __typename?: 'UserLocation', id: string, position: number, cityZip: string, radius: string }> } | null };

export type NavAccountSettingsUpdateMutationVariables = Exact<{
  input: AccountSettingsUpdateInput;
}>;


export type NavAccountSettingsUpdateMutation = { __typename?: 'Mutation', accountSettingsUpdate: { __typename?: 'AccountSettingsUpdatePayload', user: { __typename?: 'User', id: string, digestPreference: DigestPreference, userLocations: Array<{ __typename?: 'UserLocation', id: string, position: number, cityZip: string, radius: string }> } } };

export type LoginMutationVariables = Exact<{
  input: CredentialsUserAuthInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'CredentialsUserAuthPayload', user?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } };

export type EmailTokenAuthMutationVariables = Exact<{
  input: EmailTokenUserAuthInput;
}>;


export type EmailTokenAuthMutation = { __typename?: 'Mutation', emailTokenUserAuth: { __typename?: 'EmailTokenUserAuthPayload', success: boolean, csrfToken: string } };

export type EmailAuthChallengeMutationVariables = Exact<{
  input: EmailUserAuthChallengeInput;
}>;


export type EmailAuthChallengeMutation = { __typename?: 'Mutation', emailUserAuthChallenge: { __typename?: 'EmailUserAuthChallengePayload', success: boolean } };

export type ViewerUpdateMutationVariables = Exact<{
  input: ViewerUpdateInput;
}>;


export type ViewerUpdateMutation = { __typename?: 'Mutation', viewerUpdate: { __typename?: 'ViewerUpdatePayload', user: { __typename?: 'User', id: string, avatarThumbUrl?: string | null } } };

export type UpdateProfileMutationVariables = Exact<{
  input: ViewerUpdateInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', viewerUpdate: { __typename?: 'ViewerUpdatePayload', user: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | null, createdAt?: string | null, avatarThumbUrl?: string | null } } };

export type UserSignupMutationVariables = Exact<{
  input: UserSignupInput;
}>;


export type UserSignupMutation = { __typename?: 'Mutation', userSignup: { __typename?: 'UserSignupPayload', success: boolean } };

export type UserAvatarFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, avatarThumbUrl?: string | null };

export type UserDetailsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserDetailsQuery = { __typename?: 'Query', node?:
    | { __typename?: 'Listing' }
    | { __typename?: 'SearchKeyword' }
    | { __typename?: 'User', firstName: string, lastName: string, userRole: UserRole, fullName: string, email?: string | null }
    | { __typename?: 'UserLocation' }
    | { __typename?: 'WaitlistEntry' }
    | { __typename?: 'WatchedListing' }
   | null };

export type WatchlistQueryVariables = Exact<{ [key: string]: never; }>;


export type WatchlistQuery = { __typename?: 'Query', watchedListings: Array<{ __typename?: 'WatchedListing', id: string, listing: { __typename?: 'Listing', id: string, title?: string | null, price?: string | null, photoUrl?: string | null, listingUrl?: string | null, endsAt?: string | null, location?: string | null, source: string } }> };

export type WatchlistDeleteMutationVariables = Exact<{
  input: WatchedListingDeleteInput;
}>;


export type WatchlistDeleteMutation = { __typename?: 'Mutation', watchedListingDelete: { __typename?: 'WatchedListingDeletePayload', success: boolean } };

export const CachedUiAccessContextFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedUiAccessContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UiAccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canInternalAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<CachedUiAccessContextFragment, unknown>;
export const CachedViewerContextFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedViewerContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}}]}}]} as unknown as DocumentNode<CachedViewerContextFragment, unknown>;
export const UserAvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}}]}}]} as unknown as DocumentNode<UserAvatarFragment, unknown>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Users"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"searchKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}}]}},{"kind":"Field","name":{"kind":"Name","value":"waitlistEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const UserSearchSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSearchSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"searchKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"cityZip"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserSearchSettingsQuery, UserSearchSettingsQueryVariables>;
export const AdminUserSearchSettingsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminUserSearchSettingsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminUserSearchSettingsUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminUserSearchSettingsUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"searchKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"cityZip"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminUserSearchSettingsUpdateMutation, AdminUserSearchSettingsUpdateMutationVariables>;
export const InternalAdminAddKeywordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminAddKeyword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminAddKeywordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminAddKeyword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"searchKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}}]}},{"kind":"Field","name":{"kind":"Name","value":"waitlistEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminAddKeywordMutation, InternalAdminAddKeywordMutationVariables>;
export const InternalAdminDeleteKeywordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminDeleteKeyword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminDeleteKeywordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminDeleteKeyword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<InternalAdminDeleteKeywordMutation, InternalAdminDeleteKeywordMutationVariables>;
export const AdminWaitlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminWaitlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminWaitlistEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"expandedKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"matchedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<AdminWaitlistQuery, AdminWaitlistQueryVariables>;
export const ImportWaitlistKeywordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportWaitlistKeywords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminImportWaitlistKeywordsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminImportWaitlistKeywords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<ImportWaitlistKeywordsMutation, ImportWaitlistKeywordsMutationVariables>;
export const UpdateWaitlistExpandedKeywordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWaitlistExpandedKeywords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminUpdateWaitlistExpandedKeywordsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminUpdateWaitlistExpandedKeywords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waitlistEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expandedKeywords"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateWaitlistExpandedKeywordsMutation, UpdateWaitlistExpandedKeywordsMutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const UiAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UiAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uiAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canInternalAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UiAccessQuery, UiAccessQueryVariables>;
export const ViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CachedViewerContext"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedViewerContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}}]}}]} as unknown as DocumentNode<ViewerQuery, ViewerQueryVariables>;
export const SearchKeywordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchKeywords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"activeListingCount"}},{"kind":"Field","name":{"kind":"Name","value":"auctionNinjaCount"}},{"kind":"Field","name":{"kind":"Name","value":"ctbidsCount"}}]}}]}}]} as unknown as DocumentNode<SearchKeywordsQuery, SearchKeywordsQueryVariables>;
export const ListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Listings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endingToday"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"keywords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keywords"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"endingToday"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endingToday"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"listingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<ListingsQuery, ListingsQueryVariables>;
export const SearchKeywordCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SearchKeywordCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchKeywordCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchKeywordCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchKeyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"activeListingCount"}},{"kind":"Field","name":{"kind":"Name","value":"auctionNinjaCount"}},{"kind":"Field","name":{"kind":"Name","value":"ctbidsCount"}}]}}]}}]}}]} as unknown as DocumentNode<SearchKeywordCreateMutation, SearchKeywordCreateMutationVariables>;
export const SearchKeywordDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SearchKeywordDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchKeywordDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchKeywordDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SearchKeywordDeleteMutation, SearchKeywordDeleteMutationVariables>;
export const SearchKeywordReorderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SearchKeywordReorder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchKeywordReorderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchKeywordReorder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SearchKeywordReorderMutation, SearchKeywordReorderMutationVariables>;
export const SearchKeywordUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SearchKeywordUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchKeywordUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchKeywordUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchKeyword"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"keyword"}}]}}]}}]}}]} as unknown as DocumentNode<SearchKeywordUpdateMutation, SearchKeywordUpdateMutationVariables>;
export const WatchedListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WatchedListings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watchedListings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<WatchedListingsQuery, WatchedListingsQueryVariables>;
export const WatchedListingCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WatchedListingCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WatchedListingCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watchedListingCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watchedListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WatchedListingCreateMutation, WatchedListingCreateMutationVariables>;
export const WatchedListingDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WatchedListingDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WatchedListingDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watchedListingDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<WatchedListingDeleteMutation, WatchedListingDeleteMutationVariables>;
export const NavUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NavUserSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"digestPreference"}},{"kind":"Field","name":{"kind":"Name","value":"userLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"cityZip"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}}]}}]}}]}}]} as unknown as DocumentNode<NavUserSettingsQuery, NavUserSettingsQueryVariables>;
export const NavAccountSettingsUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NavAccountSettingsUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountSettingsUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountSettingsUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"digestPreference"}},{"kind":"Field","name":{"kind":"Name","value":"userLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"cityZip"}},{"kind":"Field","name":{"kind":"Name","value":"radius"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NavAccountSettingsUpdateMutation, NavAccountSettingsUpdateMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CredentialsUserAuthInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"login"},"name":{"kind":"Name","value":"credentialsUserAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const EmailTokenAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailTokenAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailTokenUserAuthInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailTokenUserAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"csrfToken"}}]}}]}}]} as unknown as DocumentNode<EmailTokenAuthMutation, EmailTokenAuthMutationVariables>;
export const EmailAuthChallengeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailAuthChallenge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailUserAuthChallengeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailUserAuthChallenge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<EmailAuthChallengeMutation, EmailAuthChallengeMutationVariables>;
export const ViewerUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerUpdateMutation, ViewerUpdateMutationVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CachedViewerContext"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedViewerContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const UserSignupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserSignup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSignupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSignup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UserSignupMutation, UserSignupMutationVariables>;
export const UserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<UserDetailsQuery, UserDetailsQueryVariables>;
export const WatchlistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Watchlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watchedListings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"listingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<WatchlistQuery, WatchlistQueryVariables>;
export const WatchlistDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WatchlistDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WatchedListingDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watchedListingDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<WatchlistDeleteMutation, WatchlistDeleteMutationVariables>;